import { EventEmitter, Output } from '@angular/core';
import { first } from 'rxjs/operators';
import { CartService } from './../cart.service';
import { Component, OnInit, Input } from '@angular/core';
import { AssignmentProposal } from '../assignment-proposal.model';
import { Cart } from '../cart.model';
import { MatDialog } from '@angular/material/dialog';
import { AssignmentProposalAnswerDialogComponent } from '../assignment-proposal-answer-dialog/assignment-proposal-answer-dialog.component';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-assignment-proposal-list-item',
  templateUrl: './assignment-proposal-list-item.component.html',
  styleUrls: ['./assignment-proposal-list-item.component.css']
})
export class AssignmentProposalListItemComponent implements OnInit {

  @Input()
  proposal: AssignmentProposal;

  @Output()
  answered = new EventEmitter<boolean>();

  cart: Cart;

  constructor(private cartService: CartService, private matDialog: MatDialog, private router: Router, private matSnackBar: MatSnackBar, private activatedRoute: ActivatedRoute) { }

  async ngOnInit() {
    this.cart = await this.cartService.get(this.proposal.cart.id).pipe(first()).toPromise();

    // FIXME: move in itineraries component
    const intentProposalId = (await this.activatedRoute.queryParamMap.pipe(first()).toPromise()).get("proposal");
    if (intentProposalId === this.proposal.id) {
      this.onClick();
    }
  }

  async onClick() {
    const answer = await this.matDialog.open(AssignmentProposalAnswerDialogComponent, {
      width: '50%',
      data: { cart: this.cart, proposal: this.proposal }
    }).afterClosed().toPromise();
    if (answer === true || answer === false) {
      this.answered.emit(answer);
    }
    if (answer === true) {
      this.router.navigate(['/itineraries', this.proposal.itinerary.id]);
      this.matSnackBar.open("✔️ Perfetto! Ti sei aggiudicato questa oppurtunità di realizzare questo itinerario. Buon lavoro!", null, {
        duration: 3000
      });
    } else if (answer === false) {
      this.matSnackBar.open("✔️ Peccato, hai rifiutato questa opportunità. Alla prossima!", null, {
        duration: 3000
      });
    }
  }

}
